export const routing = {
    computed: {
        /** This file is using vue-router route param globally */
        isMessaging() {
            return (
                this.$route.name === 'ao-armor.messaging.index' ||
                this.$route.name === 'ao-armor.messaging.messages'
            );
        },
        queryParams() {
            return new URLSearchParams(window.location.search);
        },
    },
    methods: {
        scrollToElement(element) {
            const el = document.getElementById(element);

            if (el) {
                el.scrollIntoView({ behavior: 'smooth' });
            }
        },
    },
};
